var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.b{clip-path:url(#a);}.c{stroke:#fff;stroke-miterlimit:10;stroke-width:4px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 64,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M9.669,51.836l13.561-6.2H40.313s3.086-.154,4.26,2.215a3.362,3.362,0,0,1,.32,1.613c-.045,1.355-.643,3.759-4.332,3.759H28.55",
    transform: "translate(-1.389 -10.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.483,54.512,6.7,51.4l8.848,13.38,1.428,2.16L10.98,70.83",
    transform: "translate(-0.069 -11.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M45.248,50.84l12.208-4.889a6.582,6.582,0,0,1,2.841-.558l.071,0a3.941,3.941,0,0,1,3.619,5.4c-.024.055-.049.111-.075.167a6.131,6.131,0,0,1-2.971,2.848L45.024,61.42H24.841l-6.1,3.406",
    transform: "translate(-2.692 -10.121)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M42.615,1.918c-3.015-1.9-7.279-.777-9.773,2.715C30.349,1.142,26.085.016,23.07,1.918c-3.487,2.2-4.607,8.011-1.821,12.489,1.468,2.36,5.387,5.377,8.767,7.7,1.019.7,1.989,1.34,2.827,1.879.838-.539,1.808-1.178,2.827-1.879,3.379-2.327,7.3-5.344,8.767-7.7C47.222,9.929,46.1,4.119,42.615,1.918Z",
    transform: "translate(-0.842 4.14)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEtc);
export default __webpack_public_path__ + "static/media/icon_etc.7d41d046492257779dc3e467ec93a8db.svg";
export { ForwardRef as ReactComponent };